import { render } from "./countryWarning.vue?vue&type=template&id=0f81e266&scoped=true&lang=pug"
import script from "./countryWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./countryWarning.vue?vue&type=script&setup=true&lang=js"

import "./countryWarning.vue?vue&type=style&index=0&id=0f81e266&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f81e266"]])

export default __exports__